// Was die PDFs, die das CRM im Browser baut, vom Browser brauchen – die
// Unterlage für die Montage (UnterlageSeite.tsx) und seit E3c (S4) die
// Dach-Unterlage (../ablauf/PartieKarten.tsx): jedes Foto samt Zeichnung als
// JPEG, das Logo, und das Sichern der fertigen Datei.
//
// Alle Fotos aller Seiten teilen sich EINE Reihe – umgerechnet wird eins nach
// dem anderen (Code-Prüfung E3b, Befund 1; Safari begrenzt den Speicher
// aller Leinwände zusammen).

import { dateiAdresse } from "../anzeige.ts";
import { warteschlange } from "./druckfassung.ts";
import { fotoMitZeichnungJpeg, type PdfFotoWerkzeug } from "./pdf-foto.ts";
import type { PdfWerkzeug } from "./unterlage-pdf.ts";

/** Die eine Reihe für alles Umrechnen von Fotos – Druckfassung und PDF. */
export const nacheinander = warteschlange();

/** Bild und Leinwand für die Fotos im PDF (pdf-foto.ts). */
const FOTO_IM_BROWSER: PdfFotoWerkzeug<ImageBitmap> = {
  bildAus: (roh) => createImageBitmap(roh),
  leinwand: () => document.createElement("canvas"),
};

/** Was das PDF vom Browser braucht: jedes Foto samt Zeichnung als JPEG (in derselben Reihe wie die Druckfassung) und das Logo. */
export const PDF_IM_BROWSER: PdfWerkzeug = {
  fotoJpeg: (foto, pixel) =>
    nacheinander(async () => {
      const antwort = await fetch(dateiAdresse(foto.pruefsumme), { credentials: "same-origin" });
      if (!antwort.ok) return null;
      return fotoMitZeichnungJpeg(await antwort.blob(), foto.zeichnung, pixel, FOTO_IM_BROWSER);
    }),
  logoPng: async () => {
    const antwort = await fetch("/logo-horizontal.png");
    return antwort.ok ? new Uint8Array(await antwort.arrayBuffer()) : null;
  },
};

/** Die fertige Datei sichern – Safari braucht die Blob-Adresse noch einen Moment, deshalb erst später freigeben. */
export function pdfHerunterladen(pdf: Uint8Array, dateiname: string): void {
  const adresse = URL.createObjectURL(new Blob([pdf.slice()], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = adresse;
  link.download = dateiname;
  link.rel = "noopener";
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(adresse), 60_000);
}
